
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgChevronArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.81 2.15L6.493 7.238a.772.772 0 01-.486.211.707.707 0 01-.462-.186L.206 2.146a.667.667 0 01.923-.963l4.878 4.68 4.878-4.674a.666.666 0 01.923.96h.001z"
  })));
}

export { SvgChevronArrowDown as default };
//# sourceMappingURL=chevron-arrow-down.svg.js.map
